import { useTheme } from "@/lib/theme";

/**
 * Sun or moon: the theme the page is in, and one tap to the other one.
 *
 * The tap always makes an explicit choice. Going back to following the
 * system is in the account menu, where it is a sentence rather than a
 * third icon state nobody can read.
 */
export default function ThemeToggle() {
  const { choice, effective, set } = useTheme();
  const next = effective === "dark" ? "light" : "dark";
  return (
    <button
      type="button"
      onClick={() => set(next)}
      aria-label={`Switch to the ${next} theme`}
      title={`Theme: ${effective}${choice ? "" : " (matching your system)"}`}
      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-(--color-ink-muted) hover:bg-(--color-surface-sunken) hover:text-(--color-ink)"
    >
      {effective === "dark" ? (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
          <path
            d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
          <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8" />
          <path
            d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M4.9 19.1l1.8-1.8M17.3 6.7l1.8-1.8"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      )}
    </button>
  );
}
